import { render, staticRenderFns } from "./ad.vue?vue&type=template&id=72efff95"
import script from "./ad.vue?vue&type=script&lang=js"
export * from "./ad.vue?vue&type=script&lang=js"
import style0 from "./ad.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports